/* eslint-disable no-underscore-dangle */

const onRevoke = (): void => {
  if (typeof window !== 'undefined') {
    document.cookie = '__kla_off=true';
  }
};

export default onRevoke;
